export const categories = [
  {
    id: 1,
    name: 'Dekoratif Tablolar',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20handmade%203D%20relief%20wall%20art%20frame%20with%20purple%20flowers%20orchid%20and%20colorful%20bouquet%20on%20soft%20cream%20background%20minimalist%20aesthetic%20decorative%20home%20decor&width=400&height=400&seq=cat1&orientation=squarish',
    badge: 'Popüler',
    color: 'bg-pink-50'
  },
  {
    id: 2,
    name: 'Aile & Çift Tasarımları',
    image: 'https://readdy.ai/api/search-image?query=Warm%20handmade%20wooden%20frame%20with%20tulip%20bouquet%20gold%20vase%20family%20name%20personalized%203D%20relief%20craft%20on%20soft%20beige%20cream%20background%20elegant%20family%20keepsake%20design&width=400&height=400&seq=cat2&orientation=squarish',
    badge: 'Özel',
    color: 'bg-amber-50'
  },
  {
    id: 3,
    name: 'Çocuk Tasarımları',
    image: 'https://readdy.ai/api/search-image?query=Cute%20handmade%203D%20relief%20circular%20wooden%20frame%20with%20sweet%20child%20figure%20balloons%20flowers%20colorful%20pastel%20background%20personalized%20name%20frame%20kids%20room%20decoration&width=400&height=400&seq=cat3&orientation=squarish',
    badge: 'Sevimli',
    color: 'bg-yellow-50'
  },
  {
    id: 4,
    name: 'Bebek Odası Tasarımları',
    image: 'https://readdy.ai/api/search-image?query=Adorable%20handmade%203D%20relief%20nursery%20wall%20art%20with%20cute%20bunny%20rabbit%20balloon%20hot%20air%20balloon%20soft%20pastel%20pink%20blue%20frame%20personalized%20baby%20name%20room%20decor&width=400&height=400&seq=cat4&orientation=squarish',
    badge: 'Yeni',
    color: 'bg-rose-50'
  },
];
